import React from 'react';
import { useParams } from 'react-router-dom';
import { HeaderPublic } from '../../../layout/header_public';
import { OdrLoadingSpinner } from '@/components/ui/spinner';
import { Button } from '@/components/ui/button';
import { useAuthenticationState } from '@/store/useAuthenticationState';
import { ComplianceStatus } from './ComplianceStatus';

export const TempComplianceLogin = () => {
  const { token } = useParams<{ token: string }>();
  const { authenticationState, setAuthenticationStateJWT, setAuthenticationStateLogin } = useAuthenticationState();
  const [complete, setComplete] = React.useState(false);

  const loginToken = React.useMemo(() => {
    try {
      return decodeURIComponent(`${token || ''}`.trim());
    } catch (_error) {
      return '';
    }
  }, [token]);

  React.useEffect(() => {
    if (!loginToken || complete) {
      return;
    }

    setAuthenticationStateLogin(loginToken);
  }, [complete, loginToken, setAuthenticationStateLogin]);

  if (!loginToken) {
    return (
      <div className="min-h-screen bg-gray-100 flex flex-col">
        <HeaderPublic />
        <div className="flex-1 flex items-center justify-center px-4">
          <div className="w-full max-w-xl rounded-md bg-white p-6 text-center shadow">
            <h1 className="text-lg font-semibold text-gray-900">Temp Login Unavailable</h1>
            <p className="mt-2 text-sm text-gray-600">The login link is missing or invalid.</p>
          </div>
        </div>
      </div>
    );
  }

  if (complete) {
    return (
      <div className="min-h-screen bg-gray-100 flex flex-col">
        <HeaderPublic />
        <div className="flex-1 flex items-center justify-center px-4">
          <div className="w-full max-w-xl rounded-md bg-white p-6 text-center shadow">
            <Button onClick={() => { window.location.href = '/login'; }}>
              Return to Login
            </Button>
          </div>
        </div>
      </div>
    );
  }

  if (authenticationState !== loginToken) {
    return (
      <div className="min-h-screen bg-gray-100 flex flex-col">
        <HeaderPublic />
        <div className="flex-1 flex items-center justify-center">
          <OdrLoadingSpinner />
        </div>
      </div>
    );
  }

  return (
    <ComplianceStatus
      heading="Account Update Required"
      promoteOnClear={false}
      onCleared={() => {
        setAuthenticationStateJWT('');
        setComplete(true);
      }}
    />
  );
};

export default TempComplianceLogin;
